import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import NoNavbar from '../layouts/NoNavbar.vue'
import WithNavbar from '../layouts/WithNavbar.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: WithNavbar,
        children: [
            {
                path: '/',
                name: 'DashboardView',
                component: () => import('../views/DashboardView.vue'),
                meta: { breadcrumb: 'Dashboard' }
            },
        ],
    },
    {
        path: '/login',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'Login',
                component: () => import('../views/Login.vue'),
            },
        ],
    },
    {
        path: '/signup',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'Signup',
                component: () => import('../views/Signup.vue'),
            },
        ],
    },
    {
        path: '/forgot-password',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'ForgotPassword',
                component: () => import('../views/ForgotPassword.vue'),
            },
        ],
    },
    {
        path: '/pending-policies',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'PendingPolicies',
                component: () => import('../views/PendingPoliciesView.vue'),
            },
        ],
    },
    {
        path: '/reset-password',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'ResetPassword',
                component: () => import('../views/ResetPassword.vue'),
            },
        ],
    },
    {
        path: '/view/patients/:patientId/form-signatures/:formId/edit',
        component: WithNavbar,
        children: [
            {
                path: '',
                name: 'FormSignatureEdit',
                component: () => import('../views/FormSignatureView.vue'),
                meta: { breadcrumb: 'Form Signature' }
            },
        ],
    },
    {
        path: '/public-form-signature/:token',
        component: NoNavbar,
        children: [
            {
                path: '',
                name: 'PublicFormSignature',
                component: () => import('../views/PublicFormSignatureView.vue'),
                meta: { breadcrumb: 'Public Form Signature' }
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    await store.restored;
    const isAuthenticated = store.getters.isAuthenticated;
    const publicPages = ['Login', 'Signup', 'ForgotPassword', 'ResetPassword', 'PublicFormSignature'];
    if (!publicPages.includes(to.name) && !isAuthenticated) next({ name: 'Login' });
    else {
        next();
    }
});

export default router
